import React, { useEffect, useState } from 'react';
import { useComponents } from '@tencent/dz-elements';
import { useMessageById, useConsultModel } from '../../../hooks';
import styles from './style/index.less';
var MedicalTip = function (props) {
    var messageId = props.messageId;
    var messageState = useMessageById(messageId);
    var _a = messageState.payload.message, message = _a === void 0 ? '' : _a;
    var _b = useComponents(), View = _b.View, Text = _b.Text, Modal = _b.Modal;
    var consultModel = useConsultModel();
    // eslint-disable-next-line @typescript-eslint/naming-convention
    var platform_type = consultModel.getConsultConfig().platform_type;
    var _c = useState(''), messageFront = _c[0], setMessageFront = _c[1];
    var _d = useState(''), messageBehindFir = _d[0], setMessageBehindFir = _d[1];
    var _e = useState(''), messageBehindSec = _e[0], setMessageBehindSec = _e[1];
    var _f = useState(false), showServiceModal = _f[0], setShowServiceModal = _f[1];
    var click = function () {
        setShowServiceModal(true);
    };
    useEffect(function () {
        if (platform_type === 21 || platform_type === 28) {
            var _a = messageState.payload.message, message_1 = _a === void 0 ? '' : _a;
            var _b = message_1.split('\n'), messageFront_1 = _b[0], messagebehind = _b[1];
            if (messagebehind) {
                var _c = messagebehind.split('{text}'), messageBehindFir_1 = _c[0], messageBehindSec_1 = _c[1];
                setMessageFront(messageFront_1);
                setMessageBehindFir(messageBehindFir_1);
                setMessageBehindSec(messageBehindSec_1);
            }
        }
        ;
    }, [message]);
    var onClose = function () {
        setShowServiceModal(false);
    };
    return (React.createElement(View, { className: styles['medical-tip-container'] },
        platform_type === 21 || platform_type === 28 ? (messageFront && messageBehindFir && messageBehindSec && (React.createElement(View, { className: styles['medical-tip'] },
            React.createElement(Text, { className: styles['medical-tip-content'] + " " + styles['mediacl-tip-title'], content: "\u6E29\u99A8\u63D0\u793A" }),
            React.createElement(Text, { className: styles['medical-tip-content'], content: messageFront }),
            React.createElement(View, null,
                React.createElement(View, { className: styles['medical-tip-text'] + " " + styles['medical-tip-content'] },
                    messageBehindFir,
                    React.createElement(View, { onClick: click, className: styles['medical-tip-text'] + " " + styles['medical-text-colors'] }, '《智能客服产品服务协议》'),
                    messageBehindSec))))) : (React.createElement(View, { className: styles['medical-tip'] },
            React.createElement(Text, { className: styles['medical-tip-content'] + " " + styles['mediacl-tip-title'], content: "\u6E29\u99A8\u63D0\u793A" }),
            React.createElement(Text, { className: styles['medical-tip-content'], content: message }))),
        showServiceModal && (React.createElement(Modal, { show: showServiceModal, maskColor: "rgba(0,0,0,.45)", style: {
                position: 'absolute',
                bottom: 0,
                height: '80%',
                backgroundColor: '#FFF',
                width: '100%',
                maxWidth: '100%',
            }, className: "" + styles['modal-container'], maskClosable: true, onHide: onClose },
            React.createElement(View, { className: styles['modal-header'] },
                React.createElement(Text, { className: styles['modal-title'], content: '\u667A\u80FD\u5BA2\u670D\u4EA7\u54C1\u670D\u52A1\u534F\u8BAE' }),
                React.createElement(View, { className: styles['modal-close'], onClick: onClose })),
            React.createElement("iframe", { src: 'https://leads.gdtimg.com/qzone/biz/gdt/fmc_consult/images/ProductServiceAgreement.pdf', className: styles['modal-iframe'], height: "100%", width: '100%' })))));
};
export default MedicalTip;
